"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSupportedCurrencyList = exports.isSupportedCurrency = exports.getCurrencyByCode = exports.formatCurrencyDisplay = exports.formatCurrency = exports.DEFAULT_CURRENCY = exports.SUPPORTED_CURRENCIES = void 0;
// Pre-defined currency configurations
exports.SUPPORTED_CURRENCIES = {
    NAD: {
        code: "NAD",
        symbol: "N$",
        name: "Namibian Dollar",
        locale: "en-NA",
    },
    ZAR: {
        code: "ZAR",
        symbol: "R",
        name: "South African Rand",
        locale: "en-ZA",
    },
    USD: {
        code: "USD",
        symbol: "$",
        name: "US Dollar",
        locale: "en-US",
    },
    EUR: {
        code: "EUR",
        symbol: "€",
        name: "Euro",
        locale: "en-EU",
    },
    GBP: {
        code: "GBP",
        symbol: "£",
        name: "British Pound",
        locale: "en-GB",
    },
    BWP: {
        code: "BWP",
        symbol: "P",
        name: "Botswana Pula",
        locale: "en-BW",
    },
    ZMW: {
        code: "ZMW",
        symbol: "ZK",
        name: "Zambian Kwacha",
        locale: "en-ZM",
    },
    ZWL: {
        code: "ZWL",
        symbol: "Z$",
        name: "Zimbabwean Dollar",
        locale: "en-ZW",
    },
};
// Default currency (Namibian Dollar for LEWFIN)
exports.DEFAULT_CURRENCY = exports.SUPPORTED_CURRENCIES.NAD;
/**
 * Format an amount using the specified currency configuration
 * @param amount - The numeric amount to format
 * @param currency - Currency configuration object
 * @param options - Additional formatting options
 */
var formatCurrency = function (amount, currency, options) {
    if (currency === void 0) { currency = exports.DEFAULT_CURRENCY; }
    if (options === void 0) { options = {}; }
    var _a = options.minimumFractionDigits, minimumFractionDigits = _a === void 0 ? 2 : _a, _b = options.maximumFractionDigits, maximumFractionDigits = _b === void 0 ? 2 : _b, _c = options.showSymbol, showSymbol = _c === void 0 ? true : _c;
    var formattedAmount = amount.toLocaleString(currency.locale, {
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: maximumFractionDigits,
    });
    return showSymbol ? "".concat(currency.symbol).concat(formattedAmount) : formattedAmount;
};
exports.formatCurrency = formatCurrency;
/**
 * Format currency for display with automatic thousands separators
 * Maintains compatibility with existing formatCurrency functions
 * @param amount - The numeric amount to format
 * @param currency - Currency configuration (defaults to NAD)
 */
var formatCurrencyDisplay = function (amount, currency) {
    if (currency === void 0) { currency = exports.DEFAULT_CURRENCY; }
    return (0, exports.formatCurrency)(amount, currency, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        showSymbol: true,
    });
};
exports.formatCurrencyDisplay = formatCurrencyDisplay;
/**
 * Get currency configuration by code
 * @param currencyCode - ISO 4217 currency code
 * @returns Currency configuration or default
 */
var getCurrencyByCode = function (currencyCode) {
    return exports.SUPPORTED_CURRENCIES[currencyCode === null || currencyCode === void 0 ? void 0 : currencyCode.toUpperCase()] || exports.DEFAULT_CURRENCY;
};
exports.getCurrencyByCode = getCurrencyByCode;
/**
 * Validate if a currency code is supported
 * @param currencyCode - Currency code to validate
 */
var isSupportedCurrency = function (currencyCode) {
    return (currencyCode === null || currencyCode === void 0 ? void 0 : currencyCode.toUpperCase()) in exports.SUPPORTED_CURRENCIES;
};
exports.isSupportedCurrency = isSupportedCurrency;
/**
 * Get list of all supported currencies for dropdown/selection
 */
var getSupportedCurrencyList = function () {
    return Object.values(exports.SUPPORTED_CURRENCIES);
};
exports.getSupportedCurrencyList = getSupportedCurrencyList;
